import React, { MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { TileButton, TileButtonProps } from '@printdeal/ui-library';

import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import { DeliveryToolSettings } from '../../../../../../../types/file-delivery/FileDelivery';
import { SanitizedLineItem } from '../../../../../../../types/order/Order';
import ChooseDeliveryToolModal from './ChooseDeliveryToolModal';

interface ChooseDeliveryToolThumbButtonProps {
  lineItem: SanitizedLineItem;
  deliveryMethods: string[];
  deliveryToolSettings: DeliveryToolSettings;
  dispatchEventCategory: DispatchCategoriesAccount;
  thumbSize?: TileButtonProps['size'];
  thumbClasses?: string;
}

const ChooseDeliveryToolThumbButton = ({
  lineItem,
  deliveryMethods,
  deliveryToolSettings,
  dispatchEventCategory = 'order_detail_interaction',
  thumbSize = 'lg',
  thumbClasses = '',
}: ChooseDeliveryToolThumbButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (event: MouseEvent) => {
    event.preventDefault();
    setIsModalOpen(true);
    dispatchAccountEvent(dispatchEventCategory, 'modal_choose_delivery_tool_open');
  };

  const handleCloseModal = (eventName: string) => {
    setIsModalOpen(false);
    dispatchAccountEvent(dispatchEventCategory, eventName);
  };

  return (
    <>
      <TileButton
        size={thumbSize}
        icon="image"
        onClick={handleOpenModal}
        className={thumbClasses}
      >
        <FormattedMessage id="account.order.deliverFiles.button" defaultMessage="Click here to deliver your designs" />
      </TileButton>
      {
        isModalOpen && (
          <ChooseDeliveryToolModal
            lineItem={lineItem}
            deliveryMethods={deliveryMethods}
            deliveryToolSettings={deliveryToolSettings}
            handleCloseModal={handleCloseModal}
            dispatchEventCategory={dispatchEventCategory}
          />
        )
      }
    </>
  );
};

export default ChooseDeliveryToolThumbButton;
